import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const TopBar = styled.div`
  background-color: ${props => props.theme.navBackgroundColor};
`

function Header({ children, theme }) {
  return (
    <TopBar theme={theme} className="topbar d-print-none">
      {children}
    </TopBar>
  )
}

Header.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
}

Header.defaultProps = {
  children: null,
}

export default Header



// WEBPACK FOOTER //
// ./src/components/layout/Header.jsx